module.exports = __webpack_public_path__ + "static/media/icon_order_school.d63ac5d4.svg";